import { Map } from 'immutable';

import UserConstants from 'Shared/constants/Users.constants';

export const getId = user => {
  if (!Map.isMap(user)) {
    return false;
  }
  return user.get(UserConstants.Model.ID, '');
};

export const getSlug = user => {
  if (!Map.isMap(user)) {
    return false;
  }
  return user.get(UserConstants.Model.SLUG, '');
};

export const getFirstName = user => {
  if (!Map.isMap(user)) {
    return false;
  }
  return user.get(UserConstants.Model.FIRST_NAME, '');
};

export const getDisplayName = user => {
  if (!Map.isMap(user)) {
    return false;
  }
  return user.get(UserConstants.Model.DISPLAY_NAME, '');
};

export const getFullName = user => {
  if (!Map.isMap(user)) {
    return false;
  }
  return user.get(UserConstants.Model.FULL_NAME, '');
};

export const getEmail = user => {
  if (!Map.isMap(user)) {
    return false;
  }
  return user.get(UserConstants.Model.EMAIL, '');
};

export const getAvatar = user => {
  if (!Map.isMap(user)) {
    return Map();
  }
  return user.get(UserConstants.Model.AVATAR, Map());
};
